export const DEFAULT_LABELS = ['High Priority', 'Medium Priority', 'Low Priority', 'Blocked'];

const compareLabels = (l1, l2) => {
    const l1Index = l1.default ? DEFAULT_LABELS.indexOf(l1.name) : (l1.name || '').toLowerCase();
    const l2Index = l2.default ? DEFAULT_LABELS.indexOf(l2.name) : (l2.name || '').toLowerCase();

    if (l1.default && !l2.default) {
        return -1;
    }

    if (l2.default && !l1.default) {
        return 1;
    }

    if (l1Index > l2Index) return 1;
    if (l1Index < l2Index) return -1;

    return 0;
}

export const sortLabels = labels => labels.sort((l1, l2) => compareLabels(l1, l2));

export const compareMultipleSortedLabels = (labels1, labels2) => {
    if (!labels1?.length && !labels2?.length) {
        return 0;
    }

    if (!labels1?.length) {
        return 1;
    }

    if (!labels2?.length) {
        return -1;
    }

    const result = compareLabels(labels1.shift(), labels2.shift());

    if (result === 0) {
        return compareMultipleSortedLabels(labels1, labels2);
    }

    return result;
}
